module.exports = __webpack_public_path__ + "media/SAF-1500-1_Ares_AIChatbots_2025.a81b9f85.mp4";